import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FARM_ADDRESS_ONE_LINE } from '../constants/address';
import './Legal.css';

const pageVariants = {
  initial: { opacity: 0 },
  animate: { opacity: 1, transition: { duration: 0.35 } },
  exit: { opacity: 0, transition: { duration: 0.2 } },
};

const PrivacyPolicy = () => (
  <motion.main className="legal-page" variants={pageVariants} initial="initial" animate="animate" exit="exit">
    <div className="container">
      <p className="legal-page__eyebrow">Legal</p>
      <h1>Privacy Policy</h1>
      <p className="legal-page__updated">Last updated: April 12, 2026</p>
      <div className="legal-page__prose">
        <p>
          Cory Blossom (&quot;we,&quot; &quot;our,&quot; or &quot;us&quot;) operates this website and farm pickup services in the Finger Lakes region of New York. This Privacy Policy describes how we collect, use, and protect your information when you use our site, create an account, place an order, or contact us.
        </p>

        <h2>Information we collect</h2>
        <ul>
          <li><strong>Account &amp; orders:</strong> name, email address, phone number (if provided), order history, pickup preferences, and payment-related metadata processed by our payment and order systems.</li>
          <li><strong>Communications:</strong> messages you send via contact forms, wedding inquiries, or email.</li>
          <li><strong>Technical data:</strong> browser type, general location (e.g., region), and usage data collected through standard server logs or analytics, where used.</li>
        </ul>

        <h2>How we use your information</h2>
        <p>We use your information to:</p>
        <ul>
          <li>Process and fulfill orders, including farm pickup scheduling</li>
          <li>Communicate about your order, account, or inquiries</li>
          <li>Improve our products, website, and customer experience</li>
          <li>Comply with legal obligations and protect our rights</li>
        </ul>

        <h2>Sharing of information</h2>
        <p>
          We do not sell your personal information. We may share data with service providers who assist us with hosting, email, payments, or analytics, subject to appropriate safeguards. We may disclose information if required by law or to protect the safety of our customers or business.
        </p>

        <h2>Cookies &amp; similar technologies</h2>
        <p>
          We may use cookies or local storage for essential site functionality (for example, staying signed in or remembering cart contents). You can control cookies through your browser settings.
        </p>

        <h2>Data retention &amp; security</h2>
        <p>
          We retain information as long as needed to provide services, meet legal requirements, and resolve disputes. We use reasonable administrative and technical measures to protect your data, though no method of transmission over the internet is completely secure.
        </p>

        <h2>Your choices</h2>
        <p>
          You may update account information through your profile where available, or contact us to request access, correction, or deletion of certain personal data, subject to applicable law and legitimate business needs (such as completed order records).
        </p>

        <h2>Children&apos;s privacy</h2>
        <p>
          Our services are not directed to children under 13. We do not knowingly collect personal information from children under 13.
        </p>

        <h2>Changes</h2>
        <p>
          We may update this policy from time to time. The &quot;Last updated&quot; date will change when we do. Continued use of the site after changes constitutes acceptance of the updated policy.
        </p>

        <h2>Contact</h2>
        <p>
          Cory Blossom — {FARM_ADDRESS_ONE_LINE} (Finger Lakes region). For privacy questions, contact us at{' '}
          <a href="mailto:coryblossom22@gmail.com">coryblossom22@gmail.com</a>
          {' '}or via our <Link to="/contact">Contact</Link> page.
        </p>
      </div>
    </div>
  </motion.main>
);

export default PrivacyPolicy;
